import type { FuncKey } from './keys';

export const ro: Partial<Record<FuncKey, string>> = {
  'app.eyebrow': 'Matematică · Funcții',
  'app.title': 'Funcții',
  'panel.params': 'Parametri',
  'panel.experiment': 'Experiment',
  'panel.formula': 'Formulă',
  'panel.table': 'Tabel',
  'panel.graph': 'Grafic',
  'panel.verbal': 'Descriere verbală',
  'hint.line1': 'Trageți glisoarele, editați expresii, urmăriți graficul actualizându-se.',
  'hint.line2':
    'Fiecare experiment se concentrează pe o operație: familii, transformări, compoziție, inverse, proprietăți, ramuri, reprezentări.',
  'experiment.family-zoo.label': 'Zoo de funcții',
  'experiment.transformations.label': 'Transformări',
  'experiment.composition.label': 'Compoziție',
  'experiment.inverses.label': 'Inverse',
  'experiment.domain-range-lab.label': 'Laborator domeniu/imagine',
  'experiment.behavior-and-features.label': 'Comportament & trăsături',
  'experiment.piecewise-builder.label': 'Constructor pe ramuri',
  'experiment.representations.label': 'Reprezentări',
  'experiment.family-zoo.info':
    'Alegeți o familie de funcții, glisați parametrii, urmăriți graficul.',
  'experiment.transformations.info':
    'Aplicați a·f(b·(x − h)) + k unei funcții de bază; observați cum fiecare parametru schimbă forma.',
  'experiment.composition.info':
    'Compuneți două funcții; explorați restricțiile de domeniu care apar.',
  'experiment.inverses.info':
    'Reflectați o funcție peste y = x. Restricționarea domeniului poate fi necesară pentru inversibilitate.',
  'experiment.domain-range-lab.info':
    'Trageți capetele intervalului pentru a restricționa domeniul; urmăriți modificările imaginii.',
  'experiment.behavior-and-features.info':
    'Identificați zerourile, extremele, intersecțiile și asimptotele.',
  'experiment.piecewise-builder.info':
    'Construiți funcții pe ramuri; evidențiați continuitatea sau salturile.',
  'experiment.representations.info':
    'Vedeți aceeași funcție ca formulă, tabel, grafic și descriere verbală.',
  'btn.reset': 'Resetează',
  'btn.reset-view': 'Resetează vizualizarea',
  'btn.randomise': 'Aleatoriu',
  'btn.reveal': 'Arată',
  'btn.add-piece': 'Adaugă ramură',
  'btn.remove-piece': 'Șterge ramura',
  'btn.clear-all': 'Șterge tot',
  'btn.swap': 'Schimbă',
  'btn.animate': 'Animă',
  'btn.auto-find': 'Identifică automat',
  'btn.auto-domain': 'Detectează domeniul natural',
  'readout.selected-domain': 'Domeniu selectat',
  'readout.natural-domain': 'Domeniu natural',
  'readout.image-of-domain': 'Interval y eșantionat pe domeniul selectat',
  'readout.no-finite-outputs': 'Nicio valoare finită',
  'family.linear.label': 'Liniară',
  'family.quadratic.label': 'Pătratică',
  'family.cubic.label': 'Cubică',
  'family.polynomial.label': 'Polinom',
  'family.rational.label': 'Rațională',
  'family.exponential.label': 'Exponențială',
  'family.logarithmic.label': 'Logaritmică',
  'family.absolute-value.label': 'Valoare absolută',
  'family.square-root.label': 'Radical',
  'family.sin.label': 'Sinus',
  'family.cos.label': 'Cosinus',
  'family.tan.label': 'Tangentă',
  'param.family.label': 'Familie',
  'param.parent.label': 'Arată funcția părinte',
  'param.predict-mode.label': 'Mod predicție',
  'param.a.label': 'a (scalare verticală)',
  'param.b.label': 'b (scalare orizontală)',
  'param.h.label': 'h (translație orizontală)',
  'param.k.label': 'k (translație verticală)',
  'param.base.label': 'Funcția de bază',
  'param.show-stepwise.label': 'Arată în pași',
  'param.f.label': 'f(x)',
  'param.g.label': 'g(x)',
  'param.order.label': 'Ordine',
  'param.show-intermediate.label': 'Arată intermediarul g(x₀)',
  'param.show-domain-restriction.label': 'Arată restricția domeniului',
  'param.restrict.label': 'Restricționează domeniul',
  'param.restrict.not-needed': 'Deja injectivă — nu este necesară restricția',
  'param.restrict.use-branch': 'Folosește ramura injectivă',
  'param.restrict.unavailable': 'Nu este disponibilă nicio sugestie automată de ramură',
  'param.restrict.custom': 'Definește o ramură injectivă personalizată',
  'param.show-yx.label': 'Arată y = x',
  'param.domain-start.label': 'Început domeniu',
  'param.domain-end.label': 'Sfârșit domeniu',
  'param.output-range-start.label': 'Început imagine',
  'param.output-range-end.label': 'Sfârșit imagine',
  'param.show-excluded.label': 'Arată punctele excluse',
  'param.show-derivative.label': 'Arată derivata formală',
  'param.pieces.label': 'Exemplu',
  'param.piece-expression.label': 'Formulă',
  'param.piece-start.label': 'Început',
  'param.piece-end.label': 'Sfârșit',
  'param.endpoint-included.label': 'Inclus',
  'param.endpoint-excluded.label': 'Exclus',
  'piece.label': 'Ramura',
  'param.highlight-discontinuities.label': 'Evidențiază discontinuitățile',
  'param.continuity-check.label': 'Verificare continuitate',
  'param.range-start.label': 'Început',
  'param.range-end.label': 'Sfârșit',
  'param.range-step.label': 'Pas',
  'param.precision.label': 'Precizie',
  'param.show-verbal.label': 'Arată descrierea verbală',
  'feature.vertex': 'Vârf',
  'feature.zero': 'Zero',
  'feature.extrema': 'Extreme',
  'feature.zeros': 'Zerouri',
  'feature.extremum-min': 'Min',
  'feature.extremum-max': 'Max',
  'feature.y-intercept': 'intersecția cu Oy',
  'feature.vertical-asymptote': 'AV',
  'feature.horizontal-asymptote': 'AO',
  'preset.step.label': 'Treaptă — −1 / 0 / 1 pe trei intervale',
  'preset.heaviside.label': 'Heaviside — 0 pentru x < 0; 1 pentru x ≥ 0',
  'preset.tent.label': 'Cort — x + 1 apoi 1 − x pe [−1, 1]',
  'preset.relu.label': 'ReLU — 0 pentru x ≤ 0; x pentru x > 0',
  'preset.custom.label': 'Ramuri personalizate',
  'message.predict-correct': 'Corect!',
  'message.predict-wrong': 'Mai încearcă',
  'message.not-invertible-without-restriction': 'Nu este inversabilă fără restricție',
  'message.restriction-not-one-to-one': 'f(x) trebuie să fie injectivă pe domeniul selectat',
  'message.numerical-inverse': 'inversa numerică a lui f(x)',
  'message.inverse-domain-unresolved': 'domeniul inversei nu a fost determinat',
};
